import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { domainLanding } from '@fe/common/constants/env'
import { COLOR, FONT_SIZE, PADDING, SCREEN } from '@fe/common/constants/main'
import { configSelector } from 'src/state/selectors/globalDataSelectors'
import { getSecurityNoticeConfig } from 'src/state/selectors/securityNoticeSelectors'
import { accessTokenSelector } from 'src/state/selectors/sessionSelectors'

const Container = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 8rem;
  padding: 0 ${PADDING.MOBILE}rem;

  ${SCREEN.ABOVE_MOBILE} {
    padding: 0 ${PADDING.DESKTOP}rem;
  }
`

const FooterLink = styled.a`
  color: ${COLOR.GREY};

  :hover {
    color: ${COLOR.BLACK};
  }

  :not(:last-child) {
    margin-right: 2rem;
  }

  ${SCREEN.ABOVE_MOBILE} {
    :not(:last-child) {
      margin-right: 5rem;
    }
  }
`

// 103rem = the page content column of `LoggedInLayout` (110rem minus its
// desktop padding on both sides), so the line starts on the content's left edge.
export const SecurityLine = styled.p`
  width: 100%;
  max-width: ${110 - 2 * PADDING.DESKTOP}rem;
  padding: 1.5rem 0;
  color: ${COLOR.OFF_BLACK};
  font-size: ${FONT_SIZE.SMALL};
  line-height: 1.5;
  text-align: left;
`

interface FooterProps {
  className?: string
}

export const Footer: React.FC<FooterProps> = ({ className }) => {
  const { t } = useTranslation()
  const { company_name: company } = useSelector(configSelector)
  const securityNotice = getSecurityNoticeConfig()
  const accessToken = useSelector(accessTokenSelector)

  return (
    <Container className={className}>
      {false && (
        <FooterLink
          data-test-id="domain_landing"
          href={`https://${domainLanding}`}
          rel="noopener nonrefferer"
          target="_blank"
        >
          {company}
        </FooterLink>
      )}
      {false && (
        <Link href="/docs/terms.pdf" prefetch={false} passHref>
          <FooterLink
            data-test-id="term_of_use"
            rel="noopener nonrefferer"
            target="_blank"
          >
            {t('common:terms-of-use')}
          </FooterLink>
        </Link>
      )}

      {/* Paylinka only: the brand has an entry in the security notice config map.
          Shown only with a session (owner's decision), never on logged-out pages.
          The modal is a separate component, mounted by the logged-in layouts. */}
      {securityNotice && accessToken && (
        <SecurityLine data-test-id="security_notice_footer">
          {t('common:security-notice-footer', {
            company: securityNotice.company,
            officialChannels: securityNotice.officialChannels,
          })}
        </SecurityLine>
      )}
    </Container>
  )
}
